/**
 * @generated SignedSource<<02a21442deb853228f96f50c2c948311>>
 * @relayHash 9a039c6d9d0be63ff8e144d267c3d5b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd67c905f58306b86c0078d349a6b4aa40bbd108ca7341fc3793ab4b63718892

import type { ConcreteRequest } from 'relay-runtime';
export type useUnitLinkedResourcesQuery$variables = {
  id: string;
};
export type useUnitLinkedResourcesQuery$data = {
  readonly admin_unitLinkedResource: {
    readonly id: string;
    readonly links: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      }> | null;
    };
  } | null;
};
export type useUnitLinkedResourcesQuery = {
  response: useUnitLinkedResourcesQuery$data;
  variables: useUnitLinkedResourcesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AdminUnitLinkedResource",
    "kind": "LinkedField",
    "name": "admin_unitLinkedResource",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "AdminUnitLinkedConnection",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "concreteType": "AdminUnitLinkedEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AdminUnitLinkedTo",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUnitLinkedResourcesQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUnitLinkedResourcesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "bd67c905f58306b86c0078d349a6b4aa40bbd108ca7341fc3793ab4b63718892",
    "metadata": {},
    "name": "useUnitLinkedResourcesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "00f4b510e60df83f3495aaf321054181";

export default node;
